<template>
  <div id='top_main'>
    <el-header id="header">
      <div class="hideAside">
        <img src="@/assets/logo_txt.png" style="margin-top: 5px;">
        <!-- <span>
          <span id="zh_title">互联网 + 企业</span>
        </span> -->
        <span>
          <span class="span_line">|</span>
          <span class="menu_name">进境种苗检验检疫管理系统</span>
        </span>
      </div>
      <ul class="personal">
        <li class="fullScreen" @click="fullScreen">
          <el-tooltip class="item" effect="dark" content="全屏" placement="bottom"><i class="fa fa-arrows-alt fa-lg"></i>
          </el-tooltip>
        </li>
        <li>
          <i class="fa el-icon-user-solid"></i>
          欢迎您，{{this.$store.getters.user.EntName}}
          <span v-if="$store.getters.user.OrgName">[{{this.$store.getters.user.OrgName}}]</span>
        </li>
        <li>
          <span style="color: #fff; font-family: Microsoft YaHei; font-size: 20px;">|</span>
        </li>
        <li>
          <a class="roll-nav roll-right" style="color: #fff; font-family: Microsoft YaHei; font-size: 14px;">
            {{this.$store.getters.user.UserName}}
          </a>
        </li>
        <li>
          <span style="color: #fff; font-family: Microsoft YaHei; font-size: 20px;">|</span>
        </li>
        <li>
          <i class="el-icon-switch-button"></i>
          <a href="#" @click="logout" class="roll-nav roll-right"
            style="color: #fff; font-family: Microsoft YaHei; font-size: 14px;">退出</a>
        </li>
        <!-- <li>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{this.$store.getters.user.DisplayName}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">{{ $t('userDropdownMenu.basicInfor') }}</el-dropdown-item>
              <el-dropdown-item command="b">{{   }}</el-dropdown-item>
              <el-dropdown-item command="logout" divided> 登出 </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li class="icon"><img :src="$store.getters.user.headimgurl?$store.getters.user.headimgurl:avatar" />
        </li> -->
      </ul>
    </el-header>
  </div>
</template>

<script>
// import Cookies from 'js-cookie'

export default {
  name: 'Header',
  data () {
    return {
      isfullScreen: true,
      avatar: './static/images/toux.png'
    }
  },
  methods: {
    collapse () {
      this.$store.dispatch('collapse')
    },
    fullScreen () {
      if (this.isfullScreen)
      {
        var docElm = document.documentElement
        if (docElm.requestFullscreen)
        {
          docElm.requestFullscreen()
        } else if (docElm.mozRequestFullScreen)
        {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen)
        {
          docElm.webkitRequestFullScreen()
        } else if (elem.msRequestFullscreen)
        {
          elem.msRequestFullscreen()
        }
        this.isfullScreen = false
      } else
      {
        if (document.exitFullscreen)
        {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen)
        {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen)
        {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen)
        {
          document.msExitFullscreen()
        }
        this.isfullScreen = true
      }
    },
    logout () {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('rolenames'); 
      var keys = document.cookie.match(/[^ =;]+(?==)/g)
      if (keys)
      {
        for (var i = keys.length; i--;)
        {
          document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
          document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .customs.gov.cn
          document.cookie = keys[i] + '=0;path=/;domain=customs.gov.cn;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .customs.gov.cn
        }
      }
      this.$axios.post('/Logout.ashx')
        .then((data) => {
          window.location.href = this.$logouturl;
        })
        .catch(() => {
          window.location.href = this.$logouturl;
        });
    }
  }
}
</script>

<style lang="scss">
$top: top;
$bottom: bottom;
$left: left;
$right: right;
$leftright: ($left, $right);
%w100 {
  width: 100%;
}

%h100 {
  height: 100%;
}

%cursor {
  cursor: pointer;
}

html,
body,
#app,
.el-container,
#asideNav,
ul.el-menu {
  @extend %h100;
}

@mixin set-value($side, $value) {
  @each $prop in $leftright {
    #{$side}-#{$prop}: $value;
  }
}

#header {
  background-color: #205bd1;
  max-height: 50px;
  line-height: 50px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  .hideAside {
    @extend %cursor;
    display: flex;
  }
  .personal {
    display: flex;
    flex-direction: row;
    li {
      @include set-value(margin, 10px);
      font-size: 14px;
      color: #fff;
    }
    .fullScreen {
      @extend %cursor;
    }
    .el-dropdown-link {
      @extend %cursor;
    }
    .icon img {
      margin-#{$top}: 4px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      width: 40px;
      height: 40px;
    }
  }
}
#zh_title {
  color: #fff;
  font-family: "微软雅黑", SimSun, KaiTi, KaiTi_GB2312, FangSong;
  font-size: 18px;
  line-height: 60px;
  margin-left: 15px;
}
.span_line {
  color: #fff;
  font-family: Microsoft YaHei;
  font-size: 30px;
  line-height: 50px;
  margin-left: 20px;
  font-weight: bold;
}
.menu_name {
  color: #fff;
  font-family: Microsoft YaHei;
  font-size: 25px;
  line-height: 50px;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/header/header.vue